import { useSearchParams } from 'react-router-dom';
import Loader from '../../../../globalComponents/loader/DPLoader';
import { useInviteUserDetails } from '../hooks/useInviteUserDetails';
import InviteUserForm from './PublicInviteUserForm';
import StatusMessageScreen from '../../../../core-components/theme/components/StatusMessageScreen';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function InviteUserFormContainer() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const inviteToken = searchParams.get('inviteToken') || '';
  const {
    inviteUserDetails,
    isInviteUserDetailsLoading,
    inviteUserDetailsError,
    inviteUserDetailsVerified,
    inviteUserDetailsMessage,
  } = useInviteUserDetails(inviteToken);

  if (!inviteToken) {
    return (
      <StatusMessageScreen
        type="negative"
        messageHeading="Invalid Invitation Link"
        messageBody="Please check your invitation URL and try again."
      />
    );
  }
  if (inviteUserDetailsVerified) {
    toast.success(inviteUserDetailsMessage || 'Invitation already verified');
    navigate('/Login', { replace: true });
  }

  if (isInviteUserDetailsLoading) return <Loader />;

  if (inviteUserDetailsError) {
    const errorMessage =
      (inviteUserDetailsError as any)?.message ||
      (inviteUserDetailsError as Error)?.message ||
      'Failed to load invite details';
    
    return (
      <StatusMessageScreen
        type="negative"
        messageHeading="Error Loading Invitation"
        messageBody={errorMessage}
      />
    );
  }

  if (!inviteUserDetails) {
    return (
      <StatusMessageScreen
        type="negative"
        messageHeading="No Invite Details Found"
        messageBody="The invitation details could not be retrieved. Please contact support."
      />
    );
  }

  return (
    <InviteUserForm
      key={inviteToken}
      inviteToken={inviteToken}
      initialData={inviteUserDetails}
    />
  );
}
